import 'css-chunksrc/client/pages/documentsPage/documentsPage/dropPreview/styles.scss';export default {
  "dropPreview": "_dropPreview_5cz8a_1",
  "icon": "_icon_5cz8a_17",
  "message": "_message_5cz8a_22"
};